$(document).ready(function() {
    // zobrazeni formuláře na základě zvolených dat
    $(function () {
        $('[data-shopify-login-btn]').on('click', function(ev) {
            ev.preventDefault();
            $('[data-shopify-register-content]').hide();
            $('[data-shopify-login-content]').show();
        });

        $('[data-shopify-register-btn]').on('click', function(ev) {
            ev.preventDefault();
            $('[data-shopify-register-content]').show();
            $('[data-shopify-login-content]').hide();
        });
    });
});
